import styled from "styled-components"

export const InputContainer = styled.div `
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    
`
export const IconContainer = styled.div`
    margin-right: 10px;
`
export const InputText = styled.input `
    background: transparent;
    color: #fff;
    width: 100%;
    font-size: 1rem;
`
